import { getAssetUrl } from '../getAssetUrl';
import { textStyles } from '../textStyles';
import { getChakraVarExpression } from '../utils/chakraVar';
const disabledStyles = {
    bg: 'brand.gray-scale-border-20',
    filter: 'none',
    color: 'brand.gray-scale-border-20',
    opacity: 1,
};
export const Button = {
    baseStyle() {
        return { borderRadius: '8px', textTransform: 'capitalize' };
    },
    variants: {
        primary: {
            bg: 'gradients.blue-green-horizontal',
            color: 'brand.black',
            transition: 'filter .2s',
            _hover: {
                bg: 'gradients.blue-green-horizontal',
                filter: 'brightness(1.2)',
                _disabled: {
                    ...disabledStyles,
                },
            },
            _active: {
                bg: 'gradients.blue-green-horizontal',
                filter: 'brightness(0.9)',
                _disabled: {
                    ...disabledStyles,
                },
            },
            _disabled: {
                ...disabledStyles,
            },
            _loading: {
                bg: 'gradients.blue-green-horizontal!important',
                opacity: 1,
                color: 'brand.black!important',
            },
        },
        secondary: (props) => {
            const borderColor = props.borderColor ?? 'gradients.blue-green-horizontal';
            const disabledStyles = {
                opacity: '1',
                background: 'brand.gray-scale-gray-disabled',
                backgroundClip: 'text',
                borderColor: 'brand.gray-scale-gray-disabled',
                _before: {
                    display: 'none',
                },
                _loading: {
                    background: borderColor,
                    backgroundClip: 'text',
                    '& .chakra-spinner': {
                        bg: 'gradients.blue-green-horizontal',
                        maskImage: `url(${getAssetUrl('/masks/spinner.svg')})`,
                        maskSize: '100% 100%',
                        maskRepeat: 'no-repeat',
                    },
                    _before: {
                        display: 'block',
                    },
                },
            };
            return {
                borderWidth: '1px',
                borderColor: 'transparent',
                position: 'relative',
                background: borderColor,
                backgroundClip: 'text',
                _hover: {
                    backgroundClip: 'unset',
                    color: 'brand.black',
                    _before: {
                        display: 'none',
                    },
                    _disabled: disabledStyles,
                },
                _disabled: disabledStyles,
                _before: {
                    content: '""',
                    boxSizing: 'content-box',
                    borderRadius: 'inherit',
                    w: '100%',
                    h: '100%',
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    zIndex: 0,
                    bg: borderColor,
                    backgroundOrigin: 'border-box',
                    transform: 'translate(-50%, -50%)',
                    mask: [
                        `${getChakraVarExpression('colors', 'gradients.black')} padding-box`,
                        `${getChakraVarExpression('colors', 'gradients.black')} border-box`,
                    ].join(' ,'),
                    maskComposite: 'exclude',
                    /**
                     * override auto-generated property `-webkit-mask-composite`
                     */
                    WebkitMaskComposite: 'xor',
                    borderWidth: 'inherit',
                    borderColor: 'transparent',
                    borderStyle: 'solid',
                    pointerEvents: 'none',
                },
            };
        },
        round: {
            width: '40px',
            height: '40px',
            rounded: '9999px',
            bgImage: getChakraVarExpression('colors', 'gradients.sky-blue-20'),
            bgClip: 'border-box',
            bgRepeat: 'no-repeat',
            boxShadow: 'inset 0 0 0 1px rgba(255, 255, 255, 0.1)',
            borderWidth: 0,
            px: '0',
            py: '0',
            alignItems: 'center',
        },
        link: {
            _hover: {
                textDecor: 'none',
            },
        },
    },
    sizes: {
        lg: {
            ...textStyles.subtitle1,
            h: '72px',
            maxWidth: '620px',
            width: '100%',
        },
        md: {
            ...textStyles.cta,
            h: '60px',
        },
        sm: {
            ...textStyles.cta,
            h: '42px',
        },
    },
    defaultProps: {
        variant: 'primary',
    },
};
